import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthRequestModel, UserModel } from '@tsin-core/models/auth.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const AUTH_VALIDATE_USER = `${environment.apiBaseUrl}/auth/authenticate-profiile`;
const AUTH_VALIDATE_TOKEN = `${environment.apiBaseUrl}/auth/me`;
const AUTH_LOGOUT = `${environment.apiBaseUrl}/auth/authenticate-profiile`;

@Injectable({
    providedIn: 'root'
})

// The authentication service
export class AuthService {
    // Inject the http client into auth service
    http: HttpClient = inject(HttpClient);

    // Method for endpoint to validate the user and return a token
    validate(credentials: AuthRequestModel) {
        return this.http.post(AUTH_VALIDATE_USER, credentials);
    }

    validateToken(payload: { token: string; refreshToken: string }): Observable<UserModel> {
      return this.http.get<UserModel>(AUTH_VALIDATE_TOKEN, {
        headers: {
          "Authorization": `Bearer ${payload.token}`
        }
      })
    }

   refreshToken(payload: { refreshToken: string }): Observable<{ token: string; refreshToken: string }> {
        return this.http.post<{ token: string; refreshToken: string }>(`${environment.authBaseUrl}/auth/refresh`, payload);
    }

    // Method for endpoint to logout a user from the server
    logout() {
        return this.http.delete(AUTH_LOGOUT);
    }
    signUpWorkWithUs(payload: {
        firstName: string;
        lastName: string;
        email: string;
        office: string;
        role: string;
        gender: string;
        dateOfBirth: string;
        password: string;
    }) {
        return this.http.post(`${environment.apiBaseUrl}/auth/signup`, payload);
    }
}
